import { CartCouponNoticeKind } from '@/types/cart.types';

export const CART_COUPON_MAX_LENGTH = 250;

export const CART_COUPON_TOGGLE_LABEL = 'Adicionar cupom';
export const CART_COUPON_PLACEHOLDER = 'Digite o código';
export const CART_COUPON_APPLY_LABEL = 'Aplicar';
export const CART_COUPON_INPUT_LABEL = 'Código do cupom';
export const CART_COUPON_REMOVE_LABEL = 'Remover cupom';
export const CART_COUPON_APPLIED_PILL_LABEL = 'Cupom aplicado';
export const CART_COUPON_DISCOUNT_LABEL = 'Desconto';

export const CART_COUPON_APPLIED_MESSAGE = 'Cupom aplicado.';

export const cartCouponPartialMessage = (applied: number, total: number): string =>
  `Cupom aplicado a ${applied} de ${total} itens.`;

export const COUPON_NOT_APPLICABLE_BACKEND_MESSAGE = 'Cupom não pode ser aplicado';

export const CART_COUPON_GENERIC_ERROR_MESSAGE = 'Não foi possível aplicar o cupom. Tente novamente.';
export const CART_COUPON_SYNC_ERROR_MESSAGE = 'Não foi possível atualizar o carrinho. Tente novamente.';
export const CART_COUPON_REMOVE_ERROR_MESSAGE = 'Não foi possível remover o cupom. Tente novamente.';

const SENTENCE_END = /[.!?…]$/;

export function withFinalPeriod(message: string): string {
  const trimmed = message.trimEnd();

  return SENTENCE_END.test(trimmed) ? trimmed : `${trimmed}.`;
}

export type CartCouponNoticeVariant = 'success' | 'warning';

export const CART_COUPON_NOTICE_AUTO_DISMISS_MS = 3000;
export const CART_COUPON_REMOVED_AUTO_DISMISS_MS = 4000;

interface CartCouponNoticeCopy {
  variant: CartCouponNoticeVariant;
  message: string;
  autoDismissMs?: number;
}

export const CART_COUPON_NOTICES: Record<CartCouponNoticeKind, CartCouponNoticeCopy> = {
  removed: {
    variant: 'success',
    message: 'Cupom removido.',
    autoDismissMs: CART_COUPON_REMOVED_AUTO_DISMISS_MS,
  },
  forcedRemoval: {
    variant: 'warning',
    message: 'Cupom removido: os itens elegíveis não estão mais no carrinho.',
    autoDismissMs: CART_COUPON_NOTICE_AUTO_DISMISS_MS,
  },
  invalidated: {
    variant: 'warning',
    message: 'O cupom não é mais válido e foi removido.',
    autoDismissMs: CART_COUPON_NOTICE_AUTO_DISMISS_MS,
  },
  promotional: {
    variant: 'warning',
    message: 'Cupom não se aplica a itens promocionais.',
  },
};

export const CART_COUPON_NOTICE_DISMISS_LABEL = 'Fechar aviso';
